import { fg } from '@atlaskit/platform-feature-flags';
import { getAppPerfTrackingEnabled } from '../../../performance-profiling';

// This function is used to get the feature flags that should be passed down to Forge Custom UI apps
export const getPlatformFeatureFlags = (): string[] => {
	const platformFeatureFlags: string[] = [];
	// Each feature flag name is required to be an inline string for static analysis
	if (fg('platform-visual-refresh-icons')) {
		platformFeatureFlags.push('platform-visual-refresh-icons');
	}
	if (fg('platform-component-visual-refresh')) {
		platformFeatureFlags.push('platform-component-visual-refresh');
	}
	// https://switcheroo.atlassian.com/ui/gates/17cdb9ff-f909-4978-8265-2acd26e02102/key/forge-ui-iframe-analytics
	if (getAppPerfTrackingEnabled()) {
		platformFeatureFlags.push('forge-ui-iframe-analytics');
	}
	return platformFeatureFlags;
};
